import { FC } from 'react';

import { ColumnCard } from '@/components/ColumnCard';
import { MacroArgument } from '@/hooks/discovery/macro';
import { truthy } from '@/util/array';

interface ArgumentsProps {
  macroArguments: MacroArgument[] | null;
}

export const Arguments: FC<ArgumentsProps> = ({ macroArguments }) => {
  if (!macroArguments?.length) return <div className="mt-10">No arguments</div>;
  return (
    <ul aria-label="Arguments" className="mt-10 space-y-2">
      {macroArguments.filter(truthy).map((argument) => {
        return (
          <ColumnCard
            key={argument.name}
            name={argument.name}
            description={argument.description}
            type={argument.type}
            tests={undefined}
            constraints={null}
            isPrimaryKey={false}
            shouldShowLineage={false}
          />
        );
      })}
    </ul>
  );
};
